// @flow

/**
 * Takes a localized numeric string and removes any
 * characters besides the numbers and dec. separator
 * "1,234.56" => "1234.56"
 *
 * @param {string} amount Any amount string such as "1,234.56"
 * @param {string} separator the decimal separator ("." or ",")
 * @returns {string} A stripped down string such as "1234.56"
 */
export function stripInvalid(
  amount: string = '',
  separator: CurrencySeparator = '.'
) {
  return amount.replace(new RegExp(`[^\\${separator}0-9]`, 'g'), '')
}
